"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateOrderReminder = void 0;
const updateOrderReminder = async (supabase, obj) => {
    const { data, error } = await supabase.from("reminders").upsert([obj]);
    if (error) {
        throw new Error(error.message);
    }
    return data;
};
exports.updateOrderReminder = updateOrderReminder;
